module.exports = __webpack_public_path__ + "img/serve-background-02.b85da2c5.png";